/* eslint-disable */
export default {
  downloadSuccess: 'Logboek gedownload.',
  downloadFail: 'Downloaden van foutenlogboek is mislukt. Probeer het opnieuw.',
} as const;

// @key: @#@"downloadSuccess"@#@ @source: @#@"Log downloaded."@#@
// @key: @#@"downloadFail"@#@ @source: @#@"Error log download failed. Please try again."@#@
